import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "message-list",
  name: "消息列表",
  icon: "信",
  group: "国学组件",
  description: "展示国学 App 站内消息、系统通知和业务提醒。",
  defaultProps: {
    "title": "消息中心",
    "limit": 20
}
}
